import { types } from '../../actions/signUpFinal'
import { combineReducers } from 'redux'

export const loading = (state = false, action) => {
  switch (action.type) {
    case types.FINALISE_ATTEMPT: return true
    case types.FINALISE_SUCCESS:
    case types.FINALISE_FAILURE: return false
    default: return state
  }
}

export default combineReducers({
  loading,
})
